
//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime || "One Time";
      this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
      this.textSubscribeSave = this.dataset.textSubscribesave || "Subscribe \u0026 Save";
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : null
      this.productData = document.getElementById('product-data') ? JSON.parse(document.getElementById('product-data').innerText) : null;

      this.mainSelect = document.querySelector('select[name="id"]')

      this.input.addEventListener('change', ()=>{
        this.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });


      if (this.multiplyQuantity) {
        this.querySelector('input[name="quantity"]').addEventListener('change', event => {
          this.renderPlans()
        });
      } 
      this.mainSelect.addEventListener('change', (e)=>{
        this.renderPlans()
      });
      // Initial render
      this.renderPlans()
            
    }

    removeActive(){
      this.changeInputs.forEach((groupInput)=>{
        groupInput.parentElement.classList.remove('active-input');
      })
    }

    renderPlans() {
      
      this.groupsContainer.innerHTML = this.getGroupsHtml();
      this.plansContainer = this.querySelector('[data-plans]');  //obtained newly generated element
      this.changeInputs = this.groupsContainer.querySelectorAll('[name="purchase_option"]');
      this.changeInputs.forEach((groupInput)=>{
        groupInput.addEventListener('change', (e)=>{
          this.removeActive()
          e.target.parentElement.classList.add('active-input');

          var plan = this.plansContainer.querySelector('select');
          //get html with same plan name currently selected
          this.plansContainer.innerHTML = this.getPlansHtml(plan?plan.options[plan.selectedIndex].text : '');    
          //only get the select if enabled, otherwise clear selling_plan input value
          var select = this.plansContainer.querySelector('select.enabled');
          if(select) {
            select.addEventListener('change', (e)=>{
              this.updateSellingPlan(e.target.value);
            });
            if(select.querySelector('option[value="'+this.input.value+'"]')) {
              select.value = this.input.value;
            }
            select.dispatchEvent(new Event('change', {bubbles: true}));
          } else {
            this.updateSellingPlan("");
          }
        });
      });
      var currentPlan = this.getCurrentPlan();
      if(currentPlan) {
        var groupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+currentPlan.selling_plan_group_id+'"]');
      } else {
        var groupInput = this.groupsContainer.querySelector('[name="purchase_option"][value=""]');
      }
      groupInput.checked = true;
      groupInput.dispatchEvent(new Event('change', {bubbles: true}));
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (sellingPlanId) {
        this.inputFrequencyName.value = this.getCurrentGroup().selling_plans.find(x=>x.id==sellingPlanId).options[0].value;
      } else {
        this.inputFrequencyName.value = ''
      }
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    getCurrentVariant() {
      console.log('variantId', this.mainSelect.value, this.productData.variants);
      return this.productData.variants.find(variant => parseInt(variant.id) === parseInt(this.mainSelect.value));
    }
    getQuantity() {
      return this.querySelector('input[name="quantity"]').value
    }

    formatMoney (cents, format) {
      if(typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\[\[\s*(\w+)\s*\]\]/;
      var formatString = '$[[amount]]';
      console.log('formatString', formatString);
  
      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
  
        if(isNaN(number) || number == null) {return 0;}
  
        number = (number/100.0).toFixed(precision);
  
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
  
        return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }

    getGroupsHtml() {
      var currentVariant = this.getCurrentVariant();
      console.log('currentVariant', currentVariant);
      var html = '';
      var quantity = this.multiplyQuantity ? this.getQuantity() : 1;

      if(currentVariant) {
        this.productData.selling_plan_groups.forEach((group)=>{
          let priceAdjustment = group.selling_plans[0].price_adjustments;
          let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); // expected percentage
          let planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==group.id);
          if(planAlloc) {
            let optionId = `plan-option-${group.id}-${this.productData.id}`;
            let optionPrice = this.formatMoney(planAlloc.price * quantity).replace('.00', '');
            let optionDiscountedPrice = this.formatMoney(planAlloc.compare_at_price * quantity).replace('.00', '');
            let optionCompareAtPrice = currentVariant.compare_at_price != null ? this.formatMoney(currentVariant.compare_at_price * quantity).replace('.00', '') : "";
            if(optionDiscountedPrice == optionPrice)
              optionDiscountedPrice = ''
  
            html += `
              <div>
                <input type="radio" name="purchase_option" value="${group.id}" id="${optionId}" class="radio-custom" />
                <label class="radio-custom-label subscribe" for="${optionId}">` + (discount ? 'Subscribe & Pay ' : this.textSubscribe + ' ') + `<span class="option-price">${optionPrice}</span></label>
                <div data-plans></div>
              </div>
            `;
          }
        });
      }

      if(!this.productData.requiresSellingPlan) {
  let optionId = `plan-option-onetime-${this.productData.id}`;
  let optionPrice = this.formatMoney(currentVariant.price * quantity).replace('.00', '');
  let compareAtPrice = currentVariant.compare_at_price != null ? this.formatMoney(currentVariant.compare_at_price * quantity).replace('.00', '') : "";
  if(optionPrice == compareAtPrice)
    compareAtPrice = ''
  html += `
    <div>
      <input type="radio" name="purchase_option" value="" id="${optionId}" class="radio-custom" />
      <label class="radio-custom-label one-time" for="${optionId}">${this.textOnetime}: <span class="option-discount-price"><s>${compareAtPrice}</s> </span><span class="option-price">${optionPrice}</span></label>
    </div>
  `;
}
      
      return html;
    }

    getPlansHtml(selectedName) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.getCurrentVariant();
      var enabled = true;
      var currentGroup = this.getCurrentGroup();
      if (!currentGroup) {
        
        enabled = false;
      }
      var html = '';

      if(currentGroup) {
        var isOneOption = currentVariant.selling_plan_allocations.length==1;
        selectedName = selectedName.trim();
        html = '<select class="' + (enabled ? 'enabled' : '') + (isOneOption ? ' hide' : '') +'" ' + (enabled ? '' : 'disabled="disabled"') + '>';
        currentVariant.selling_plan_allocations.forEach((plan)=>{
          var sellingPlan = currentGroup.selling_plans.find(x=>x.id==plan.selling_plan_id);
          html += `<option value="${sellingPlan.id}"  `+ (selectedName==sellingPlan.name.trim() ? 'selected="selected"' : '')+`>${sellingPlan.name}</option>`;
        });
        html += `</select>`;
        if (isOneOption) {
          html += `<div class="selling-plan-name">${currentGroup.selling_plans[0].name}</div>`;
        }
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.getCurrentVariant();
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

    getCurrentGroup() {
      var groupId = this.querySelector('[name="purchase_option"]:checked').value;
      return this.productData.selling_plan_groups.find(x=>x.id==groupId);
    }
  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}
